module.exports = __webpack_public_path__ + "assets/img/guangyao.f1fe4806.png";